// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import {
  About,
  ContactUs,
  DefaultPage,
  OurInvestors,
  Partners,
  Press,
  PrivacyPolicy,
  TravelAgency,
} from './';

import Agencies from './Agencies';
import ChangeTicketPage from './ChangeTicketPage';
import ChangeTicketResponse from './ChangeTicketResponse';
import Destinations from './Destinations';
import KnowYourRights from './KnowYourRights';
import SpecialServices from './SpecialServices';
import TnC from './TnC';

// import { About } from './About';
// import  Partners  from './Partners';
// import Press from './Press';

export default {
  path: '',
  name: 'Pages',
  childRoutes: [
    // SPANISH ROUTES
    { path: 'es/pages/default-page', name: 'Default page', component: DefaultPage, isIndex: true },
    { path: 'es/pages/contact', name: 'Contact us', component: ContactUs },
    { path: 'es/pages/privacy-policy', name: 'Privacy policy', component: PrivacyPolicy },
    { path: 'es/pages/tnc', name: 'Terms and conditions', component: TnC },
    { path: 'es/pages/about', name: 'About kupos.cl', component: About },
    { path: 'es/pages/partners', name: 'Our Partners', component: Partners },
    { path: 'es/pages/press', name: 'Press', component: Press },
    { path: 'es/pages/our-investors', name: 'Our Investors', component: OurInvestors },
    { path: 'es/pages/travel-agency', name: 'Travel Agency', component: TravelAgency },
    { path: 'es/pages/know-your-rights', name: 'Know Your Rights', component: KnowYourRights },
    { path: 'es/pages/agencies', name: 'Agencias Page', component: Agencies },
    { path: 'es/pages/destinos', name: 'Travel Agency', component: Destinations },
    { path: 'es/pages/special-services', name: 'SpecialServices', component: SpecialServices },
    { path: 'es/change-ticket', name: 'Default page', component: ChangeTicketPage },
    {
      path: 'es/change-ticket-response',
      name: 'Change Ticket Response',
      component: ChangeTicketResponse,
    },

    {
      path: 'es/confirm-ticket-response',
      name: 'Confirm Ticket Response',
      component: ChangeTicketResponse,
    },

    // ENGLISH ROUTES
    { path: 'en/pages/default-page', name: 'Default page', component: DefaultPage, isIndex: true },
    { path: 'en/pages/contact', name: 'Contact us', component: ContactUs },
    { path: 'en/pages/privacy-policy', name: 'Privacy policy', component: PrivacyPolicy },
    { path: 'en/pages/tnc', name: 'Terms and conditions', component: TnC },
    { path: 'en/pages/about', name: 'About kupos.cl', component: About },
    { path: 'en/pages/partners', name: 'Our Partners', component: Partners },
    { path: 'en/pages/press', name: 'Press', component: Press },
    { path: 'en/pages/our-investors', name: 'Our Investors', component: OurInvestors },
    { path: 'en/pages/travel-agency', name: 'Travel Agency', component: TravelAgency },
    { path: 'en/pages/know-your-rights', name: 'Know Your Rights', component: KnowYourRights },
    { path: 'en/pages/agencies', name: 'Agencies Page', component: Agencies },
    { path: 'en/pages/destinations', name: 'Travel Agency', component: Destinations },
    { path: 'en/pages/special-services', name: 'SpecialServices', component: SpecialServices },
    { path: 'en/change-ticket', name: 'Default page', component: ChangeTicketPage },
    {
      path: 'en/change-ticket-response',
      name: 'Change Ticket Response',
      component: ChangeTicketResponse,
    },
    {
      path: 'en/confirm-ticket-response',
      name: 'Confirm Ticket Response',
      component: ChangeTicketResponse,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/features/pages/route.js